/**
 * @file event-form.validations.js
 * @module EventFormValidations
 * @description Vuelidate rules of the event form, mirroring the backend:
 * required name, code, dates and time zone; code format; end date on or after
 * the start date.
 */

import { required, maxLength } from "vuelidate/lib/validators";
import {
  EVENT_NAME_MAX_LENGTH,
  EVENT_CODE_MAX_LENGTH,
  EVENT_DESCRIPTION_MAX_LENGTH
} from "../constants/events.constants";
import { isValidEventCode, isEndDateValid } from "./event-form.service";

export const EVENT_FORM_VALIDATIONS = {
  name: {
    required,
    maxLength: maxLength(EVENT_NAME_MAX_LENGTH)
  },
  code: {
    required,
    maxLength: maxLength(EVENT_CODE_MAX_LENGTH),
    validCode: isValidEventCode
  },
  description: {
    maxLength: maxLength(EVENT_DESCRIPTION_MAX_LENGTH)
  },
  startDate: {
    required
  },
  endDate: {
    required,
    afterStartDate(endDate, form) {
      return isEndDateValid(endDate, form.startDate);
    }
  },
  timezone: {
    required
  }
};
